import { TYPE_ID_OPTION_CORPORATE } from './constant'

export const convertDataChartDistribution = (data) => {
  const dataFormat = data
    .map((item) => ({
      ...item,
      percentage: item?.percentage?.toFixed(3),
    }))
    .filter((item) => item?.scoreRange_Min && item?.scoreRange_Max)

  const dataIndustry = dataFormat
    .filter((item) => item.typeOrder === TYPE_ID_OPTION_CORPORATE.INDUSTRY)
    .map((key) => ({
      ...key,
      ticker: `${key.scoreRange_Min}-${key.scoreRange_Max}`,
    }))
  const dataRegion = dataFormat
    .filter((item) => item.typeOrder === TYPE_ID_OPTION_CORPORATE.REGION)
    .map((key) => ({
      ...key,
      ticker: `${key.scoreRange_Min}-${key.scoreRange_Max}`,
    }))
  const dataYear = dataFormat
    .filter((item) => item.typeOrder === TYPE_ID_OPTION_CORPORATE.YEAR)
    .map((key) => ({
      ...key,
      ticker: `${key.scoreRange_Min}-${key.scoreRange_Max}`,
    }))

  return {
    industry: dataIndustry,
    region: dataRegion,
    year: dataYear,
  }
}
